import React from 'react';
import './Chapters.scss';

function Chapter7() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">Looking to the Horizon</p>
        <p className="chapter__paragraph">
          Even as the situation in Ukraine changes and the use cases for the PCCs evolve, Hartshorn
          still looks back on the first PCC deployment at RomExpo. His colleague Dr. Tanya Murphy,
          Geeks Without Frontiers’ Director of Impact, was tasked with understanding just how the
          PCC could impact the work of NGOs working to serve refugees. Murphy and Hartshorn were
          standing outside the PCC, watching children draw and paint using tablets and smartphones
          provided by the center. It was all part of Happy Bubbles, a program designed to allow
          children to create and print art and help them feel comfortable and safe while they’re far
          from home.
        </p>
        <p className="chapter__paragraph">
          Murphy asked Florentina Dan, a field officer for the Happy Bubbles activities with the
          nonprofit World Vision, “What is the value of the PCC for the Happy Bubbles program? What
          are the outcomes?”
        </p>
        <p className="chapter__paragraph">
          “Access to information is critical for these people,” Dan told them. “It's like breathing
          oxygen. Most of Ukraine is extremely well-connected. And we have seen again and again
          people tell us—grandmothers, mothers, children—how wonderful it is to be able to express
          themselves through art.”
        </p>
        <p className="chapter__paragraph">
          As Hartshorn and Murphy listened to Dan, a little girl came up to Dan’s side, a little
          girl who hadn't been participating, and started to dance. Overcome, Hartshorn turned to
          his colleague and said, “I think we've got a good impact here, Tanya,” Looking back now,
          he adds “As these units continue to be deployed, our entire N50 team takes heart in the
          transformational power of partnership.”
        </p>
      </section>
    </>
  );
}

export default Chapter7;
